import React from "react";
import AdminAddGalleryDetails from "../../Components/Admin/AdminAddGalleryDetails";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddGalleryDetailsPage = ()=>{
    return (
      <AdminAddGalleryDetails />
    )
}

export default AdminAddGalleryDetailsPage;